import React from 'react'
import VendorNavbar from './VendorNavbar'
import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'

const VendorDashboard = () => {
  return (
    <Box>
      <VendorNavbar />
      <Box sx={{px: 7, pt: 4}}>
        <Outlet />
      </Box>
    </Box>
  )
}

export default VendorDashboard